import React, { useState } from "react";
import axios from "axios";
import "../style/emailForm.scss";

// Bilingual status copy. MailerLite's API returns data (or English-only
// technical errors), so we own the user-facing wording and key it by status.
const MESSAGES = {
  success: { en: "Thanks for subscribing!", jp: "ご登録ありがとうございます！" },
  invalid: { en: "Please enter a valid email address.", jp: "正しいメールアドレスを入力してください。" },
  error: { en: "Something went wrong. Please try again.", jp: "エラーが発生しました。もう一度お試しください。" },
};

const EmailForm = ({
  noPaddingTop = false,
  noPaddingBottom = false,
  noMobilePaddingX = false,
}) => {
  const [email, setEmail] = useState("");
  // idle | loading | success | invalid | error
  const [status, setStatus] = useState("idle");

  const loading = status === "loading";
  const feedback =
    status === "success"
      ? MESSAGES.success
      : status === "invalid"
      ? MESSAGES.invalid
      : status === "error"
      ? MESSAGES.error
      : null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setStatus("loading");
    try {
      // Only a 2xx response resolves; axios throws for 4xx/5xx (handled below).
      await axios.post("/api/subscribe", { email });
      setStatus("success");
      setEmail("");
    } catch (err) {
      // 400 from our proxy => invalid email; everything else (incl. no
      // response / network failure) => generic error.
      const code = err.response?.status;
      setStatus(code === 400 ? "invalid" : "error");
    }
  };

  return (
    <div
      className={`email-form-section container w-full px-4 ${
        noMobilePaddingX ? "no-mobile-padding-x" : ""
      }`}
    >
      <div
        className="email-form w-full max-w-[47rem] mx-auto"
        style={{
          textAlign: "center",
          paddingTop: noPaddingTop ? "0px" : "2rem",
          paddingBottom: noPaddingBottom ? "0px" : "2rem",
        }}
      >
        <div className="email-form-container">

          {/* Form Container */}
          <div
            className="relative rounded-xl border"
            style={{ backgroundColor: "#f3f3f3", borderColor: "#999999", borderWidth: "2.5px", padding: "12px 17px" }}
          >
            {/* Desktop and Mobile Layout Container */}
            <div className="email-form-content flex flex-col items-center lg:flex-row lg:items-center lg:justify-between">
              {/* Heading Section - Stacks on mobile, left-aligned on desktop */}
              <div className="email-form-heading mb-6 lg:mb-0 lg:pr-2 text-center lg:text-right">
                <h3 className="text-3xl lg:text-3xl font-bold mb-1 font-amaticsc-bold">Join our email list for the latest updates!</h3>
                <h3 className="text-lg lg:text-lg font-bold font-funneldisplay">最新情報をメールで受け取りましょう！</h3>
              </div>

              {/* Form Section - Stacks on mobile, right-aligned on desktop */}
              <div className="email-form-inputs w-[260px]">
                <form className="flex flex-col" onSubmit={handleSubmit} noValidate>
                  {/* Email Field */}
                  <div className="entry__field w-full flex justify-center">
                    <input
                      className="email input w-[260px] px-3 h-[52px]"
                      type="email"
                      name="email"
                      id="email"
                      autoComplete="off"
                      placeholder="me@email.com"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={loading}
                      style={{
                        border: "2px solid #acacac",
                        borderRadius: "0.75rem",
                        backgroundColor: "#FFFFFF",
                        outline: "none",
                        boxShadow: "none",
                      }}
                    />
                  </div>

                  {/* Submit Button */}
                  <div className="flex items-center justify-center mt-3">
                    <button
                      type="submit"
                      disabled={loading}
                      className="flex items-center justify-center h-[52px]"
                      style={{
                        color: "#616161",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "0.75rem",
                        border: "2px solid #acacac",
                        padding: "0 2rem",
                        // Inline styles outrank SCSS, so the loading look must be
                        // applied here, not via a CSS class.
                        ...(loading && { opacity: 0.6, cursor: "wait" }),
                      }}
                    >
                      <span className="font-amaticsc-bold text-2xl lg:text-3xl">JOIN ・ </span>
                      <span className="font-kleeone text-xl lg:text-xl">登録</span>
                    </button>
                  </div>

                  {/* Status message (bilingual) */}
                  {feedback && (
                    <div
                      className={`form-status ${status === "success" ? "is-success" : "is-error"}`}
                      role="status"
                      aria-live="polite"
                    >
                      <span className="form-status-en">{feedback.en}</span>
                      <span className="form-status-jp font-funneldisplay">{feedback.jp}</span>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default EmailForm;
